'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserBar = UserBar;

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _styles = require('@material-ui/core/styles');

var _Button = require('@material-ui/core/Button');

var _Button2 = _interopRequireDefault(_Button);

var _IconButton = require('@material-ui/core/IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

var _Grid = require('@material-ui/core/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _Toolbar = require('@material-ui/core/Toolbar');

var _Toolbar2 = _interopRequireDefault(_Toolbar);

var _ExitToApp = require('@material-ui/icons/ExitToApp');

var _ExitToApp2 = _interopRequireDefault(_ExitToApp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _ref = React.createElement(_ExitToApp2.default, null);

function UserBar(props) {
  var classes = props.classes,
      displayName = props.displayName,
      handleSignOut = props.handleSignOut,
      handleSignIn = props.handleSignIn,
      isAuthorized = props.isAuthorized;

  return React.createElement(
    _Toolbar2.default,
    { classes: { root: classes.root, gutters: classes.gutters } },
    isAuthorized && React.createElement(
      _Grid2.default,
      { container: true, alignContent: 'center', alignItems: 'center', justify: 'space-between', wrap: 'nowrap' },
      React.createElement(
        _Grid2.default,
        { className: classes.displayName, item: true },
        displayName
      ),
      React.createElement(
        _Grid2.default,
        { item: true },
        React.createElement(
          _IconButton2.default,
          { title: 'Sign Out', color: 'inherit', onClick: handleSignOut, 'aria-label': 'Sign Out' },
          _ref
        )
      )
    ),
    !isAuthorized && React.createElement(
      _Button2.default,
      {
        className: classes.signInButton,
        color: 'inherit',
        onClick: handleSignIn,
        'aria-label': 'Sign In'
      },
      'Sign In'
    )
  );
}

UserBar.defaultProps = {
  classes: {}
};

var styles = {
  root: {
    backgroundColor: '#666',
    color: '#fff'
  },
  gutters: {
    paddingLeft: '14px',
    paddingRight: '4px'
  },
  displayName: {
    flexShrink: '1',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  signInButton: {
    margin: '0 auto'
  }
};

exports.default = (0, _styles.withStyles)(styles)(UserBar);